import "antd/lib/modal/style";
import _Modal from "antd/lib/modal";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/typography/style";
import _Typography from "antd/lib/typography";
var __jsx = React.createElement;
import React from 'react';
var Paragraph = _Typography.Paragraph,
  Link = _Typography.Link;
var DownloadDatasetModal = function DownloadDatasetModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    onDownload = _ref.onDownload,
    isDownloading = _ref.isDownloading,
    datasetName = _ref.datasetName;
  return __jsx(_Modal, {
    title: datasetName,
    open: open,
    onCancel: onClose,
    footer: [__jsx(_Button, {
      key: "cancel",
      onClick: onClose
    }, "Cancel"), __jsx(_Button, {
      key: "download",
      type: "primary",
      loading: isDownloading,
      onClick: onDownload
    }, "Download")]
  }, __jsx(Paragraph, null, "This dataset is licensed under the Creative Commons Attribution-NonCommercial 4.0 International (", __jsx(Link, {
    href: "https://creativecommons.org/licenses/by-nc/4.0/",
    target: "_blank",
    rel: "noreferrer"
  }, "CC BY-NC 4.0"), ") license. Non-commercial users are free to share and adapt the data by providing appropriate credit \u2013 Parse Biosciences citation guidelines are available", ' ', __jsx(Link, {
    href: "https://www.parsebiosciences.com/citation-guidelines/",
    target: "_blank",
    rel: "noreferrer"
  }, "here"), ". If you're interested in licensing the data for commercial purposes, visit our", ' ', __jsx(Link, {
    href: "https://www.parsebiosciences.com/datasets-for-commercial-licensing/",
    target: "_blank",
    rel: "noreferrer"
  }, "Dataset Commercial Licensing"), ' ', "page."), __jsx(Paragraph, null, "By clicking Download, you are agreeing to these terms."));
};
export default DownloadDatasetModal;